import humanFormat from "human-format";
import { ITileCacheSeedOperation, TileCacheSeedOperationStatus } from "../MapComponents/TileCache/types";

export class formatUtils {

    public static formatOperationStatus(status: TileCacheSeedOperationStatus): string {

        switch (status) {
            case TileCacheSeedOperationStatus.Succeeded:
                return 'Complete' ;

            case TileCacheSeedOperationStatus.InProgress:
                return 'Downloading';

            case TileCacheSeedOperationStatus.Failed:
                return 'Failed' ;

            case TileCacheSeedOperationStatus.Cancelled:
                return 'Cancelled' ;

            default: 
                return '';
        }
    }

    public static formatOperationStatusLong(op: ITileCacheSeedOperation): string {

        switch (op.status) {
            case TileCacheSeedOperationStatus.Succeeded:
                return 'Complete' ;

            case TileCacheSeedOperationStatus.InProgress:
                if (!!op.downloadedTotal && !!op.downloadedBytes)
                    return `Downloading: ${op.downloadedTotal} of ${op.numTotal} (${humanFormat.bytes(op.downloadedBytes)})`;
                else if (!!op.downloadedTotal)
                    return `Downloading: ${op.downloadedTotal} of ${op.numTotal}`;
                else if (!!op.downloadedBytes)
                    return `Downloading: ${humanFormat.bytes(op.downloadedBytes)}`;
                else
                    return 'Downloading';

            case TileCacheSeedOperationStatus.Failed:
                return 'Failed' ;

            case TileCacheSeedOperationStatus.Cancelled:
                return 'Cancelled' ;

            default: 
                return '';
        }

    }

};